export default function Presentation() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-xl sm:text-2xl text-gray-700 leading-relaxed">
            En <span className="font-semibold text-[#FF7F6E]">Duendecillos Let's Play</span> combinamos educación, juego y afecto para ofrecer una experiencia única donde tu hijo crece feliz desarrollando habilidades sociales, emocionales, motoras y cognitivas, siempre respetando su ritmo.
          </p>
        </div>
      </div>
    </section>
  );
}
